import { StyleSheet } from "aphrodite/no-important";
import { colour } from "../style/base-theme";

export const styles = StyleSheet.create({
  titleWrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginTop: 25
  },
  appliancesTitle: {
    flex: 1,
    fontSize: 18,
    fontWeight: 600,
    color: colour.grey[100],
    margin: "10px 0px"
  },
  pastHour: {
    flex: 1,
    fontSize: 12,
    color: colour.grey[400],
    textAlign: "right"
  },
  onHightlight: {
    color: "#FFFFFF",
    background: colour.brand.green,
    borderRadius: 10,
    padding: "0px 5px 1px",
    fontWeight: 600
  }
});
